<template>
  <div class="page-header">
    <el-button icon="el-icon-arrow-left" @click="$emit('back')" size="medium">返回</el-button>
    <span class="title">{{title}}</span>

  </div>
</template>

<script>
export default {
  name: 'pageHeader',
  props: {
    title: String
  }
}
</script>

<style scoped lang="less">
  .title{
    font-size: 18px;
    font-weight: 600;
  }
.page-header{
  height: 60px;
  text-align: center;
  line-height: 60px;
  position: relative;
  border-bottom: 1px solid #E1E1E1;
  .el-button{
    padding: 0;
    width: 68px;
    height: 32px;
    position: absolute;
    left: 0;
    top: 13px;
  }
}
</style>
